var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{attrs:{"color":"primary","label":"Uložit","disable":!!_vm.disable || _vm.saving},on:{"click":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }